<style>
.q-tooltip {
  font-size: 15px;
}
#main .q-item-main {
  color: #888;
  font-size: 0.97rem;
}
#main footer {
  height: 38px;
  webkit-box-shadow: none;
  box-shadow: none;
  font-size: 14px;
  color: #777;
}
.menu-active {
  font-weight: bold;
  color: #1976d2; /* #1131ea */
}
.login-footer:hover {
  color: #004271;
  cursor: pointer;
  text-decoration: underline #004271;
}
</style>
<template>
  <q-layout id="main" view="lHh Lpr lFf">
    <q-drawer :behavior="screenType ? 'desktop' : 'mobile'" :width="220" :mini="mini" v-model="leftDrawerOpen" bordered :breakpoint="800"
      ><!-- content-class="bg-grey-1" -->
      <div class="bg-grey-1" style="line-height:54px;border-bottom:1px solid #eee;" :style="{ padding: mini ? '0 14px' : '0 15px' }">
        <q-btn v-if="screenType" @click="mini = !mini" aria-label="Menu" :icon="mini ? 'fa fa-arrow-right' : 'fa fa-arrow-left'" color="primary" size="sm" dense round />
        <span v-if="!mini" class="text-primary" style="font-size:1.08rem;" :style="screenType?'margin-left:30px;':''">{{ $t("index.menu") }}</span>
      </div>
      <q-list>
        <template v-for="(menu, index) in $t('MODULES_MENU')">
          <q-item active-class="menu-active" :to="menu.path" @click="menuClick(index)" exact style="height:48px;">
            <q-tooltip v-if="mini" anchor="center right" self="center left" :offset="[8, 8]" :delay="0">
              {{ menu.name }}
            </q-tooltip>
            <q-item-section avatar><q-icon :name="menu.icon" :color="index === selIndex ? 'primary' : 'grey'"/></q-item-section>
            <q-item-section>
              <q-item-label style="font-size:15px;">{{ menu.name }}</q-item-label>
            </q-item-section>
          </q-item>
          <q-separator inset />
        </template>
      </q-list>
    </q-drawer>

    <q-header>
      <q-toolbar class="shadow-2" inverted>
        <q-btn v-if="!screenType" @click="leftDrawerOpen = !leftDrawerOpen" aria-label="Menu" icon="fa fa-list fa-1x" round flat dense /><!-- v-if="$i18n.locale=='zh'"  -->
        <!-- class="glossy" v-if="$i18n.locale=='zh'" <q-btn flat dense round @click="mini=!mini" aria-label="Menu" icon="fa fa-list fa-1x"/> -->
        <div style="height:42px;padding: 0 5px;border-radius: 5px;margin-left:18px;" v-if="screenType">
          <img ref="img" :src="'./img/logo.svg'" height="100%" style="object-fit:contain;" />
        </div>
        <q-toolbar-title style="font-size:24px;font-weight:bold;">{{ $t("title") }}</q-toolbar-title>
        <!-- <q-select v-model="lang" :options="$t('langs')" option-value="val" option-label="name" emit-value map-options borderless><! style="width:148px;"
        	<template v-slot:prepend>
        		<q-icon name="fa fa-globe fa-xs" class="text-white" />
        	</template>
        </q-select>
		<q-separator vertical inset color="blue-8" class="q-mx-md"/> -->
        <q-btn-dropdown flat style="padding:16px 8px;margin-right:15px;">
          <template v-slot:label>
            <div class="row items-center no-wrap">
              <q-icon left name="fa fa-user-circle" style="font-size:1.21rem!important;" />
              <div class="text-center">{{ user && user.name ? user.name : $t("uName") }}</div>
            </div>
          </template>
          <q-list style="min-width:220px">
            <q-item class="q-my-sm">
              <q-item-section avatar>
                <q-avatar icon="fa fa-user" color="primary" text-color="white" size="32px" />
              </q-item-section>
              <q-item-section>{{ user && user.name ? user.name : $t("uName") }}</q-item-section>
              <!-- <q-item-section side>
				    <q-btn @click="userClick(3)" icon="fa fa-sign-out-alt" color="red" round flat dense v-close-popup >
						<q-tooltip anchor="top middle" self="bottom middle" :offset="[5,5]" :delay="0">
							{{$t('index.exit')}}
						</q-tooltip>
					</q-btn>
				  </q-item-section> -->
            </q-item>
            <q-separator />
            <q-item @click="userClick(1)" clickable v-close-popup>
              <q-item-section>{{ $t("index.dialog[0]") }}</q-item-section>
              <q-item-section side>
                <q-icon color="positive" name="fa fa-user-edit" size="17px" />
              </q-item-section>
            </q-item>
            <q-item @click="userClick(2)" clickable v-close-popup>
              <q-item-section>{{ $t("index.dialog[1]") }}</q-item-section>
              <q-item-section side>
                <q-icon color="amber-7" name="fa fa-user-lock" size="17px" />
              </q-item-section>
            </q-item>
            <q-separator />
            <q-item @click="userClick(3)" clickable v-close-popup>
              <q-item-section>{{ $t("index.exit") }}</q-item-section>
              <q-item-section side>
                <q-icon color="red" name="fa fa-sign-out-alt" size="17px" />
              </q-item-section>
            </q-item>
          </q-list>
        </q-btn-dropdown>

        <!-- <q-icon name="fa fa-user-circle fa-lg" class="text-white"/>
		<span class="q-mx-sm">{{user&&user.name?user.name:$t('uName')}}</span>
		<q-separator vertical inset color="blue-8" class="q-mx-xs"/>
		<q-btn @click="userClick(1)" icon="fa fa-user-edit fa-1x" class="text-white" flat round>
			<q-tooltip anchor="bottom middle" self="top middle" :offset="[6, 6]" :delay="0">
			{{$t('index.dialog[0]')}}
			</q-tooltip>
		</q-btn>
		<q-separator vertical inset color="blue-8" class="q-mx-xs"/>
		<q-btn @click="userClick(2)" icon="fa fa-sign-out-alt fa-lg" class="text-white q-mr-lg" flat round>
			<q-tooltip anchor="bottom middle" self="top middle" :offset="[6, 6]" :delay="0">
			{{$t('index.exit')}}
			</q-tooltip>
		</q-btn> -->
      </q-toolbar>
    </q-header>

    <q-page-container class="bg-grey-1">
      <router-view :lang.sync="lang" :mini.sync="mini" :user.sync="user" @getuser="getUser" @islogin="toLogin" />
    </q-page-container>

    <q-footer class="bg-grey-1"
      ><!-- bg-white -->
      <div style="text-align:center;height:38px;line-height:38px;">
        <span v-if="this.$i18n.locale == 'zh'">DESIGNMAN 版权所有 © 2020&nbsp;&nbsp;</span>
        <span v-if="this.$i18n.locale == 'en'"> DESIGNMAN All Rights Reserved © 2020</span>
        <span v-if="this.$i18n.locale == 'ru'"> DESIGNMAN Все Лрава Защищены © 2020</span>
        <span class="login-footer" @click="copyright" v-if="this.$i18n.locale == 'zh'">{{ $t("copyright") }}</span>
        <span class="login-footer" @click="copyright1" v-if="this.$i18n.locale == 'zh'">
          <img style="padding: 0 5px;vertical-align: text-bottom;" :src="'./img/GongwangAnbei.png'" />粤公网安备 44060502002019号
        </span>
      </div>
    </q-footer>

    <q-dialog v-model="dialogStatus" persistent transition-show="scale" transition-hide="scale">
      <q-card :class="[screenType ? 'q-pa-lg' : 'q-pa-sm']" :style="{ minWidth: screenType ? '450px' : '85vw', width: screenType ? '' : '65vw' }">
        <q-card-section>
          <div class="text-h6">{{ dialogType === 1 ? $t("index.dialog[0]") : $t("index.dialog[1]") }}</div>
        </q-card-section>
        <q-card-section>
          <div class="fit">
            <div>
              <!-- @submit.prevent.stop="onSubmit" @reset.prevent.stop="onReset"-->
              <!-- <q-input v-if="dialogType===1" ref="account" v-model.trim="form.account" class="q-mt-sm" :label="$t('user.name')" maxlength="20" counter :placeholder="$t('user.name')" outlined
	      			:rules="[val => !!val || $t('msg.input_msg'), val => val.length<=20&&val.length>=4 || $t('user.msg_name')]" lazy-rules/> -->
              <q-input
                v-if="dialogType === 1"
                ref="name"
                v-model.trim="form.name"
                class="q-mt-sm"
                :label="$t('user.user')"
                maxlength="20"
                counter
                :placeholder="$t('user.user')"
                outlined
                :rules="[(val) => !!val || $t('msg.input_msg'), (val) => (val.length <= 20 && val.length >= 2) || $t('user.msg_user')]"
                lazy-rules
              />
              <q-input
                v-if="dialogType === 2"
                ref="pw1"
                v-model.trim="form.oldPW"
                class="q-mt-sm"
                :label="$t('index.oldPW')"
                type="password"
                maxlength="20"
                counter
                :placeholder="$t('index.oldPW')"
                outlined
                :rules="[(val) => !!val || $t('index.help1'), (val) => (val.length <= 20 && val.length >= 4) || $t('login.msg2')]"
                lazy-rules
              />
              <q-input
                v-if="dialogType === 2"
                ref="pw2"
                v-model.trim="form.newPW"
                class="q-my-sm"
                :label="$t('index.newPW')"
                type="password"
                maxlength="20"
                counter
                :placeholder="$t('index.newPW')"
                outlined
                :rules="[(val) => !!val || $t('index.help2'), (val) => (val.length <= 20 && val.length >= 4) || $t('login.msg2'), (val) => val !== form.oldPW || $t('index.err1')]"
                lazy-rules
              />
              <q-input
                v-if="dialogType === 2"
                ref="pw3"
                v-model.trim="form.newPW2"
                class="q-my-sm"
                :label="$t('index.newPW1')"
                type="password"
                maxlength="20"
                counter
                :placeholder="$t('index.newPW1')"
                outlined
                :rules="[(val) => !!val || $t('index.help3'), (val) => (val.length <= 20 && val.length >= 4) || $t('login.msg2'), (val) => val === form.newPW || $t('index.err2')]"
                lazy-rules
              />
            </div>
          </div>
        </q-card-section>
        <q-card-actions align="right" class="bg-white text-teal">
          <q-btn :label="$t('close')" flat color="primary" class="q-mr-md" v-close-popup />
          <q-btn @click="confirm()" :disable="btnDisable" :label="$t('ok')" icon="fas fa-check" color="primary" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-layout>
</template>

<script>
import { openURL } from "quasar";
import q_zh from "quasar/lang/zh-hans";
import q_en from "quasar/lang/en-us";
import q_ru from "quasar/lang/ru";
import SparkMD5 from "spark-md5";

export default {
  data() {
    return {
      mini: false,
      leftDrawerOpen: true, //this.$q.platform.is.desktop
      lang: this.$t("langs")[0].val,
      user: null,
      selIndex: 0, //模块tablet-alt
      form: { oldPW: null, newPW: null, newPW2: null },
      dialogType: 1,
      dialogStatus: false,
      btnDisable: false,
    };
  },
  created() {
    if (this.$i18n.locale == "zh") {
      this.lang = this.$t("langs")[0].val;
      this.$q.lang.set(q_zh);
    } else if (this.$i18n.locale == "en") {
      this.lang = this.$t("langs")[1].val;
      this.$q.lang.set(q_en);
    } else if (this.$i18n.locale == "ru") {
      this.lang = this.$t("langs")[2].val;
      this.$q.lang.set(q_ru);
    }
    var version = IEVersion(); //console.log(version);
    if (typeof version == "number" && version != -1 && version < 11) {
      this.$alert("提示：请使用 IE 11 以上的浏览器 或 其他类型浏览器！！", {
        showClose: false,
        showConfirmButton: false,
      });
    }
    if (localStorage.getItem("AS_token") && localStorage.getItem("AS_token").length > 0) {
      this.getUser();
      for (var i = 0; i < this.$t("MODULES_MENU").length; i++) {
        if (this.$route.path === this.$t("MODULES_MENU")[i].path) {
          this.selIndex = i;
          break;
        }
      }
      this.$router.push(this.$t("MODULES_MENU")[this.selIndex].path);
    } else {
      this.$router.replace("/"); //login
    }
    //this.$q.loadingBar.start()
    //this.$q.loadingBar.stop()
  },
  watch: {
    lang(val, oldVal) {
      this.langChange(val);
    },
  },
  computed: {
    // 识别移动端
    screenType() {
      return _isPC(); //this.$q.platform.is.desktop
    },
  },
  methods: {
    md5(str) {
      var spark = new SparkMD5();
      spark.append(str);
      var md5Str = spark.end();
      return md5Str;
    },
    openURL,
    menuClick(key) {
      //this.lamppostData = 0;
      this.selIndex = key;
      //console.log(this.lamppostData)
      //this.selItem = key+'-0';
      //this.selected = key+'-0-0';
      //this.childVal = null;
      //if(localStorage.getItem("child")) localStorage.removeItem("child");
      //this.$router.push(this.modules[key].path); //if(key!=0)
      //console.log(this.modules[key], keyPath);
    },
    langChange(val) {
      var val2 = { zh: q_zh, en: q_en, ru: q_ru };
      localStorage.setItem("lang", val);
      this.$i18n.locale = localStorage.getItem("lang");
      this.$q.lang.set(val2[val]);
      //this.lang = this.$t('langs')[index].val;
    },
    toLogin(type, err) {
      //indexOf('401')!=-1
      if (err && typeof err == "string" && err.indexOf("401") != -1) {
        //err.code==10010
        if (type === 1) {
          this.$q
            .dialog({
              title: this.$t("msg.prompt"),
              message: this.$t("msg.token"),
              ok: true,
              cancel: false,
            })
            .onOk((res) => {
              this.$router.replace("/"); //login
              // 点击确认 登录失效，移除AS_token
              this.$notify(2, "请重新登录", null);
              localStorage.removeItem("AS_token");
            });
        } else {
          // 点击确认 登录失效，移除AS_token
          this.$notify(2, "请重新登录", null);
          localStorage.removeItem("AS_token");
          this.$router.replace("/"); //login
        }
      } else if (type === 1 && err && err.code) {
        var err_msg = null;
        err_msg = this.$t("errMsg." + err.code) != "errMsg." + err.code ? this.$t("errMsg." + err.code) : this.$t("errMsg.default");
        /*switch(err.code){
				case 10010:
					err_msg = '登录凭证校验失败或过期'; break;//token 校验失败或过期
				case 10011:
					err_msg = '登录凭证无效'; break;//token 为空
				case 10012:
					err_msg = '登录已过期，请重新登录'; break;
				case 10013:
					err_msg = '服务器无响应'; break;
				case 10014:
					err_msg = '请求参数异常'; break;
				case 20000:
					err_msg = '响应请求成功'; break;
				case 20110:
					err_msg = 'ID无效'; break;
				case 20111:
					err_msg = '数据插入失败'; break;
				case 20112:
					err_msg = '数据修改失败'; break;
				case 20113:
					err_msg = '数据删除失败'; break;
				case 20114:
					err_msg = '账号或密码错误'; break;
				case 20115:
					err_msg = '数据不存在'; break;
				case 20116:
					err_msg = '账号错误'; break;
				case 20117:
					err_msg = '密码错误'; break;
				case 20118:
					err_msg = '密码不一致，修改密码用'; break;
				case 20210:
					err_msg = 'ID为空'; break;
				case 20211:
					err_msg = '参数为空'; break;
				case 20212:
					err_msg = '参数已存在'; break;
				case 20213:
					err_msg = '参数内容不正确'; break;
				case 20410:
					err_msg = '相对服务器无响应'; break;
				case 20411:
					err_msg = 'JSON解析异常'; break;
				case 20511:
					err_msg = '系统间请求异常'; break;
				case 20512:
					err_msg = '系统间请求无响应'; break;
				case 30000:
					err_msg = '系统异常'; break;
				default:
					err_msg = err.msg||'操作失败，请稍后再试！'; break;
			}*/
        if (err_msg) this.$notify(2, err_msg, null);
      } else if (type === 1) {
        this.$notify(2, this.$t("msg.request_err"), null);
      }
    },
    getUser() {
      this.user = this.$route.params && this.$route.params.id ? this.$route.params : JSON.parse(unescape(localStorage.getItem("AS_name")));
      if (this.user.id) {
        this.$ajax(1, "get", true, "/user", null)
          .then((res) => {
            this.user = res.data;
            var data = { id: res.data.id, name: res.data.name };
            localStorage.setItem("AS_name", escape(JSON.stringify(data)));
            //console.log(this.user)
          })
          .catch((err) => {
            console.log(err);
            this.toLogin(2, err);
          });
      }
    },
    userClick(index) {
      this.dialogType = index;
      if (index == 1) {
        //修改信息
        this.$set(this.form, "account", this.user.account);
        this.$set(this.form, "name", this.user.name);
        //console.log(this.form)
        this.dialogStatus = true;
      } else if (index == 2) {
        //修改密码
        this.$set(this.form, "oldPW", null);
        this.$set(this.form, "newPW", null);
        this.$set(this.form, "newPW2", null);
        this.dialogStatus = true;
      } else if (index == 3) {
        //退出
        if (localStorage.getItem("AS_token")) localStorage.removeItem("AS_token");
        if (localStorage.getItem("AS_name")) localStorage.removeItem("AS_name");
        this.$router.replace("/login");
      }
    },
    confirm() {
      if (this.dialogType === 1) {
        //修改信息
        //this.$refs.acccunt.validate();
        this.$refs.name.validate();
        if (this.$refs.name.hasError) {
          //this.$refs.acccunt.hasError ||
          this.$notify(2, this.$t("msg.input_err"), null);
          return;
        } else {
          this.btnDisable = true;
          var request = {};
          request.id = this.user.id;
          //request.account = this.form.account;
          request.name = this.form.name;
          this.$ajax(1, "post", true, "/user", request)
            .then((res) => {
              this.dialogStatus = false;
              this.btnDisable = false;
              this.getUser();
              this.$notify(1, this.$t("index.msg"), null);
            })
            .catch((err) => {
              console.log(err);
              this.btnDisable = false;
              // 20212 User has already registered
              if (err.code === 20212) {
                this.$notify(1, "修改成功", null);
                this.dialogStatus = false;
              } else {
                this.toLogin(1, err);
              }
              // if(!err.code) this.$notify(2,err.msg,null);
            });
        }
      } else if (this.dialogType === 2) {
        //修改密码
        this.$refs.pw1.validate();
        this.$refs.pw2.validate();
        this.$refs.pw3.validate();
        if (this.$refs.pw2.hasError || this.$refs.pw1.hasError || this.$refs.pw3.hasError) {
          this.$notify(2, this.$t("msg.input_err"), null);
          return;
        } else {
          this.btnDisable = true;
          var request = {};
          request.id = this.user.id;
          request.oldPassword = this.md5(this.form.oldPW);
          request.newPassword = this.md5(this.form.newPW);
          this.$ajax(1, "post", true, "/user/updatePassword", request)
            .then((res) => {
              this.dialogStatus = false;
              if (localStorage.getItem("AS_token")) localStorage.removeItem("AS_token");
              if (localStorage.getItem("AS_name")) localStorage.removeItem("AS_name");
              this.btnDisable = false;
              this.$notify(1, this.$t("index.msg"), null);
              this.$router.replace("/"); //login
            })
            .catch((err) => {
              console.log(err);
              this.toLogin(1, err);
              this.btnDisable = false;
              //if(err.code) this.$notify(2,err.msg,null);
            });
        }
      }
    },
    copyright1() {
      window.open("http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44060502002019", "_blank");
    },
    copyright() {
      window.open("http://www.beian.miit.gov.cn/", "_blank");
    },
  },
};
</script>
